import { render, staticRenderFns } from "./diamond.vue?vue&type=template&id=050651c9&scoped=true"
import script from "./diamond.vue?vue&type=script&lang=js"
export * from "./diamond.vue?vue&type=script&lang=js"
import style0 from "./diamond.vue?vue&type=style&index=0&id=050651c9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050651c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050651c9')) {
      api.createRecord('050651c9', component.options)
    } else {
      api.reload('050651c9', component.options)
    }
    module.hot.accept("./diamond.vue?vue&type=template&id=050651c9&scoped=true", function () {
      api.rerender('050651c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/components/diamond.vue"
export default component.exports